import Emitter from '../Util/Emitter';
import Constants from '../Util/Constants';
/**
 * @class
 * @description Communication class that uses a websocket,
 * it has events for the different expected received messages and the method send
 * @extends Emitter
 * @exports WsCommunication
 */
export default class WsCommunication extends Emitter {
    /**
     * @constructs WsCommunication
     * @param {string} host Host URL
     * @public
     */
    constructor(config) {
        super();
        this._config = config;
    }
    /**
     * Opens the websocket connection
     * @returns {WsCommunication} this
     * @public
     */
    start() {
        var _a;
        (_a = this._ws) === null || _a === void 0 ? void 0 : _a.close();
        if ('undefined' !== typeof WebSocket) {
            const trackUrl = this._config.accountCode
                ? this._config.tracker + '?accountCode=' + this._config.accountCode
                : this._config.tracker;
            this._ws = new WebSocket(trackUrl);
            this._ws.onclose = () => {
                this.close();
            };
            this._ws.onmessage = (e) => {
                try {
                    this.emit(Constants.WSCommEvents.Data, JSON.parse(e.data));
                }
                catch (err) {
                    console.warn(err);
                }
            };
            this._ws.onerror = (e) => {
                this.emit(Constants.WSCommEvents.Error, e);
            };
            this._ws.onopen = (e) => {
                this.emit(Constants.WSCommEvents.Connected, e);
            };
        }
        return this;
    }
    /**
     * Sends the message using the socket
     * @param {trackerMessage} message Message object to be sent as a message by the websocket
     * @public
     */
    send(message = {}) {
        var _a;
        ((_a = this._ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 ? this._ws.send(JSON.stringify(message)) : null;
    }
    /**
     * Function to detect if the websocket has an active connection
     * @returns {boolean} if websocket is connected or not
     * @public
     */
    isConnected() {
        var _a;
        return ((_a = this._ws) === null || _a === void 0 ? void 0 : _a.readyState) === 1 || false;
    }
    /**
     * Callback and function for closed websocket connection
     * Removes the listeners
     * @public
     */
    close() {
        if (this._ws) {
            this._ws.onclose = null;
            this._ws.onmessage = null;
            this._ws.onerror = null;
            this._ws.onopen = null;
            this._ws.close();
            this.emit(Constants.WSCommEvents.Closed, this);
        }
    }
}
